module.exports = __webpack_public_path__ + "static/media/linkedin.583b8562.svg";